import React from 'react';
import './ListingCardSkeleton.scss';

interface ListingCardSkeletonProps {
  /** How many placeholder cards to render. Defaults to one. */
  count?: number;
}

/**
 * Placeholder for a big listing card while results load. Mirrors the real
 * card's geometry (240px visual, then address / headline / chips / price) so
 * the list keeps its rhythm and nothing jumps when the data lands.
 */
const ListingCardSkeleton: React.FC<ListingCardSkeletonProps> = ({ count = 1 }) => (
  <>
    {Array.from({ length: count }, (_, i) => (
      <div className="listing-card-skeleton" key={i} aria-hidden="true">
        <div className="listing-card-skeleton__visual" />
        <div className="listing-card-skeleton__content">
          <div className="listing-card-skeleton__info">
            <div className="listing-card-skeleton__line listing-card-skeleton__line--address" />
            <div className="listing-card-skeleton__line listing-card-skeleton__line--headline" />
            <div className="listing-card-skeleton__chips">
              <div className="listing-card-skeleton__chip" />
              <div className="listing-card-skeleton__chip" />
              <div className="listing-card-skeleton__chip" />
            </div>
          </div>
          <div className="listing-card-skeleton__line listing-card-skeleton__line--price" />
        </div>
      </div>
    ))}
  </>
);

export default ListingCardSkeleton;
